import { connect } from 'react-redux'
import { getApper, saveQingJiaDel } from './actions'
import Setting from './main'


const mapDispatchToProps = {
    getApper,
    saveQingJiaDel
}
const mapStateToProps = (state) => {
  return {
    ...state.QingJiaDelEditor
  }
}
  

export default connect(mapStateToProps, mapDispatchToProps)(Setting)
